import React from 'react';
import Slider from "react-slick";
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import Picture from 'Shared/Picture';

const RelatedContent = (props) => {
    const settings = {
        infinite: true,
        slidesToShow: 1,
        variableWidth: true
    };
    const renderProduct = (product) => {
        return (
            <div className="product" key={product.Id}>
                <a href={product.ProductsUrl.Value}>
                    <LazyLoadComponent>
                        <Picture
                            src={[
                                {
                                    Url: product.DetailsImage.Value + "--resize,170,170",
                                    WebpUrl: product.DetailsImage.Value + "--resize,170,170--returnTypeFile,webp"
                                },
                                {
                                    Url: product.DetailsImage.Value + "--resize,110,110",
                                    WebpUrl: product.DetailsImage.Value + "--resize,110,110--returnTypeFile,webp"
                                },
                                {
                                    Url: product.DetailsImage.Value + "--resize,170,170",
                                    WebpUrl: product.DetailsImage.Value + "--resize,170,170--returnTypeFile,webp"
                                }
                            ]}
                            alt={product.DetailsImageAlt.Value}
                        />
                    </LazyLoadComponent>
                    <div className="box">
                        <h3>{product.Title.Value}</h3>
                        <div className="bv-rating" data-bv-show="inline_rating" data-bv-product-id={product.Sku.Value !== "" ? product.Sku.Value : product.Id} />
                    </div>
                </a>
            </div>
        );
    };
    return (
        <div className="customers-also-liked product-slider">
            <h3 className="slider-title">{props.Title.Value}</h3>
            <div className="products">
                {!props.isMobile ? (
                    <Slider {...settings}>
                        {props.Products.map((product) => (
                            <div style={{ width: 410 }} key={product.Id}>
                                {renderProduct(product)}
                            </div>
                        ))}
                    </Slider>
                ) : (
                    props.Products.map((product) => (
                        renderProduct(product)
                    ))
                )}
            </div>
        </div>
    );
}
export default RelatedContent;
